import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Defensive: html5-qrcode's video element may be removed from the DOM mid-play
// (e.g. when transitioning between scan UI and error/paste UI). The pending
// video.play() then rejects with AbortError. Attach a catch at the source so
// the rejection never bubbles up as an "uncaught" error.
if (typeof HTMLMediaElement !== 'undefined') {
  const originalPlay = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function patchedPlay(this: HTMLMediaElement) {
    const result = originalPlay.apply(this) as Promise<void> | undefined;
    if (result && typeof (result as Promise<void>).catch === 'function') {
      return (result as Promise<void>).catch((err: any) => {
        if (err && (err.name === 'AbortError' || err.code === 20)) return;
        throw err;
      });
    }
    return result as any;
  };
}

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    const reason: any = event.reason;
    if (!reason) return;
    const isAbort = reason.name === 'AbortError' || reason.code === 20;
    const msg = typeof reason.message === 'string' ? reason.message : '';
    if (isAbort && /play\(\)|removed from the document/i.test(msg)) {
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
